// extracted by mini-css-extract-plugin
export default {"submittingIcon":"nUnVQ___SubmitButton-module__submittingIcon","icon":"HqjHa___SubmitButton-module__icon"};